import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#00B8AD",
      "fill-rule": "evenodd",
      d: "M6.5 11a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0 1a6 6 0 1 0 0-12 6 6 0 0 0 0 12m-.707-6L3.789 3.997l.708-.708L6.5 5.293l2.003-2.004.708.708L7.207 6l2.004 2.003-.708.708L6.5 6.707 4.497 8.711l-.708-.708z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }